import React from 'react';
import _ from 'lodash';
import SandboxActivityCard from './SandboxActivityCard';
import ActivityPopup from './ActivityPopup';
import { formatKeysToCamelCase } from '../util'

class ModuleSandboxActivityCards extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isActivityPopupVisible: false, activityData: '' }
  }

  render() {
    const { module } = this.props
    const collection = module['sandbox-activities']

    return(
      <div>
        {_.isEmpty(collection) &&
          <h3>Sorry, we're still working on activities for this module!</h3>
        }
        {_.map(collection, activity=>
          <SandboxActivityCard onClick={()=>this.setState({ activityData: formatKeysToCamelCase(activity), isActivityPopupVisible: true })} key={activity.id} activity={activity}/>
        )}

        {this.state.isActivityPopupVisible &&
          <ActivityPopup
            handleClose={()=>this.setState({ isActivityPopupVisible: false })}
            activity={this.state.activityData}
          />
        }
      </div>
    );
  }
}

export default ModuleSandboxActivityCards;
